import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { DefaultsContext } from '../../../DefaultsContext'
import { useGetRichPlacementMultianchor } from '../../hooks/useGetRichPlacementMultianchor'
import { useUpdateRichPlacementMultianchor } from '../../hooks/useUpdateRichPlacementMultianchor'
import { schema, Schema, schemaDefault } from './schema'
import { MultianchorSection } from './Section'

export const MultiAnchorForm = (): JSX.Element => {
  const { formId, setTouched, setValid } = useContext(DefaultsContext)
  const { isLoading: isFetching, multianchor } = useGetRichPlacementMultianchor()

  const { errors, isPending: isUpdating, update } = useUpdateRichPlacementMultianchor()

  if (!multianchor) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={errors}
      id={formId}
      loading={isFetching || isUpdating}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(multianchor)}
    >
      {() => <MultianchorSection />}
    </Form>
  )
}
